import React from 'react';
import _ from 'lodash';
import StyledPage, {
  StyledPageContentInner,
  StyledTopArea,
} from '../components/StyledPage';
import StyledPageHeader from '../styled-components/StyledPageHeader';
import RedirectWithPrevState from '../components/RedirectWithPrevState';
import useUser from '../apps/core/src/helpers/useUser';
import MySimulationSessions from '../apps/core/src/components/Learners/MySessions/MySimulationSessions/MySimulationSessions';
import { withLoggedInAccess } from '../apps/core/src/helpers/permissions';

const MySimulationSessionsPage = () => {
  const { ID } = useUser();

  if (!ID) {
    return <RedirectWithPrevState to="/login" />;
  }
  return (
    <StyledPage pageKey="profile">
      <StyledPageContentInner>
        <StyledPageHeader>Interactive video sessions</StyledPageHeader>
        <MySimulationSessions />
      </StyledPageContentInner>
    </StyledPage>
  );
};

MySimulationSessionsPage.propTypes = {};

export default withLoggedInAccess(MySimulationSessionsPage);
